import BaseModel from "./BaseModel";

export default class PaneObject extends BaseModel {
  public get className(): string {
    return "PaneObject"; // no itx
  }

  get isPersistent(): boolean {
    return false;
  }

  canBeDeletedInteractive(): boolean {
    return false;
  }
  type = "";
  closeable = true;

  constructor(type: string, title: string, closeable: boolean) {
    super({}, undefined);
    this.type = type;
    this.id = type;
    this.tag = title;
    this.closeable = closeable;
  }
}
